import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";
import {getJobEntryTime} from "../../utilities/job";

const JobBoardJobLogEntryTime = (props) => {
  const {logEntries, logEntry, intl} = props;
  const [nowMoment, setNowMoment] = useState(moment.utc());
  const currentEntryTimeStamp = moment.utc(logEntry.timestamp); // regex for splitting time zone
  let timeoutId = 0;

  useEffect(() => {

    let modifiedToJobEntry = null;
    const currentEntryTime = currentEntryTimeStamp.unix();
    if (Array.isArray(logEntries)) {
      modifiedToJobEntry = [...logEntries].reverse().find((entry) => {
        const compareEntryTime = moment.utc(entry.timestamp.split(/\..*$/)[0]).unix();
        return (compareEntryTime > currentEntryTime) && ((entry.type === "ChangeLeadType") || (entry.type === "ChangeJobStatus"))
      });
      if (modifiedToJobEntry) {
        setNowMoment(moment.utc(modifiedToJobEntry.timestamp.split(/\..*$/)[0])) // now the timer will calculate only once - difference between currentEntryTimeStamp and entry time // regex for splitting time zone
      }
    }

    if (!modifiedToJobEntry && (logEntry.newStatus !== "Completed") && (logEntry.newStatus !== "Dead Lead")) {
      function repeatingFunc() {
        setNowMoment(moment.utc()); // always use utc format as we are storing other time in utc too
        timeoutId = window.setTimeout(repeatingFunc, 1000)
      }
      timeoutId = window.setTimeout(repeatingFunc, 1000) // update every second new "Now" time and calculate difference between currentEntryTimeStamp and now
    }

    return () => {
      window.clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logEntries]);

  const timePassed = moment.duration(nowMoment.diff(currentEntryTimeStamp));

  return getJobEntryTime(timePassed, intl)
};

JobBoardJobLogEntryTime.propTypes = {
  logEntry: PropTypes.object.isRequired,
  logEntries: PropTypes.array.isRequired,
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobBoardJobLogEntryTime)
);
